
export default () => ({
  stopProcesses: false,
});
